import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormControl, NgForm, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Account, ClientData } from '../user-profile-details/client-data';
import Swal from 'sweetalert2';
import { RequestService } from 'src/app/services/request.service';
import { ApiService } from 'src/app/services/api.service';
import { Router } from '@angular/router';
import { SystemSettingsService } from 'src/app/services/systemSettings.service';

interface ComplaintRequest {
  DepartmentId: number;
  RelationCode: string;
  ActionType: number;
  Body:string;
}

@Component({
  selector: 'app-request-complaint-modal',
  templateUrl: './request-complaint-modal.component.html',
  styleUrls: ['./request-complaint-modal.component.scss']
})
export class RequestComplaintModalComponent implements OnInit {
  isSubmitting = false;
  @Input() selectedAccount: Account;
  titleMessage: string;
  textConfirmMassage: string;
  submitStatus;
  newComplaint: ComplaintRequest = {} as ComplaintRequest;
  complaintTypes: any[] = [];
  today = new Date();
  userPortfolio: ClientData;
  companyName: string;
  departments: any[] = [];
  userAccounts: Account[];
  selectedAccountControl = new FormControl(null, Validators.required);
  accountList: Account[];
  stepperOrientation: 'horizontal' | 'vertical' = 'horizontal';
  showDepartment: boolean = true;

  constructor(
    public translate: TranslateService,
    private requestService: RequestService,
    private apiService: ApiService,
    private router: Router,
    private systemSettingsService: SystemSettingsService
  ) { }

  ngOnInit(): void {
    this.systemSettingsService.checkSetting('Department-Visibility').subscribe(
      (isVisible) => { this.showDepartment = isVisible; },
      (err) => { this.showDepartment = true; }
    );
    this.apiService.fetchDepartments().subscribe((res)=>{this.departments=res as any[]});
    this.accountList = JSON.parse(localStorage.getItem("accList"));
    this.selectedAccount= this.accountList[0];
    this.clientSelected(this.selectedAccount);
    this.fetchUserPortfolio(this.selectedAccount);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedAccount && changes.selectedAccount.currentValue) {
      this.clientSelected(changes.selectedAccount.currentValue);
      this.fetchUserPortfolio(changes.selectedAccount.currentValue);
    }
  }

  fetchUserPortfolio(selectedAcc?) {
    if (selectedAcc) this.selectedAccount = selectedAcc;

    if (this.selectedAccount != null && this.selectedAccount.relationCode) {
      this.requestService.fetchUserPortfolio(this.selectedAccount.relationCode)
        .subscribe((res) => {
          this.userPortfolio = res as ClientData;
          this.companyName = this.userPortfolio.Profile.CompanyNameAr;
        });
    }
  }
  
  clientSelected(e: Account) {
      this.userAccounts =   JSON.parse(localStorage.getItem("accList")) as Account[];
      this.selectedAccountControl.setValue(null);
  }
  

  submitComplaint(form: NgForm) {
    if (form && form.valid) {
      this.newComplaint.DepartmentId = this.showDepartment ? form.value.DepartmentId : null;
      this.newComplaint.RelationCode = this.selectedAccount.relationCode;
      this.newComplaint.Body = form.value.Body;
      this.newComplaint.ActionType = 10;
      if (this.translate.currentLang == "ar") {
        this.titleMessage = "تأكيد الشكوى";
        this.textConfirmMassage = `برجاء مراجعه البيانات التالية قبل ارسال الشكوى
      الحساب: ${this.selectedAccount.clientNameAr}
      الشكوى:
      `;
      }
      if (this.translate.currentLang == "en") {
        this.titleMessage = "Complaint Confirmation";
        this.textConfirmMassage = `Please check The Information Before Sending The Complaint
     Account: ${this.selectedAccount.clientNameEn}
     Complaint:
     `;
      }
      Swal.fire({
        title: this.titleMessage,
        html:
          "<pre>" +
          this.textConfirmMassage +
          "</pre><p>" +
          form.form.value.Body +
          "</p>",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.translate.instant("yes"),
        cancelButtonText: this.translate.instant("no"),
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.apiService.submitAction(this.newComplaint).subscribe(
            (res) => {
              this.isSubmitting = false;
              if (res) this.submitStatus = res;
              form.resetForm();
              Swal.fire({
                position: "center",
                icon: "success",
                title: this.translate.instant("succes-msg"),
                showConfirmButton: false,
                timer: 4500,
              });
              this.router.navigate(['/requests-analysis/requests-table']);
            },
            (err) => {
              Swal.fire({
                position: "center",
                icon: "error",
                title: this.translate.instant("error-msg"),
                showConfirmButton: false,
                timer: 4500,
              });
              this.router.navigate(['/requests-analysis/requests-table']);
            }
          );
        } else if (!result.isConfirmed) {
          this.isSubmitting = false;
        }
      });
    }
  }
}